import React from "react";
import { useSelector } from "react-redux";
//import { getToken } from "../../shared/utils/LocalSessionHandler";

import * as S from "./styles";

import FavLogo from "../../assets/logo.png";
import { IState } from "../../app-state/reducer";
import { Session } from "../../models";
import { ProfileAndExit } from "./ProfileAvatar";

type Props = {
    children?: any;
};

export default function TotemNavbar(props: Props) {
    const session = useSelector<IState, Session | undefined>(
        (state) => state.session
    );

    if (!session) return null;

    return (
        <S.ContainerFade>
            <S.Nav>
                <S.Logo src={FavLogo} alt="Logo" />
            </S.Nav>
            <ProfileAndExit />
        </S.ContainerFade>
    );
}
